module.exports = __webpack_public_path__ + "static/media/background-new-login.9f0d29db.png";